// export const HUSTRA_APP_URI = "http://192.168.43.223:3000/";
export const HASTRA_APP_URI = "https://patient.hastra.us/hastra-app/api/doctors";
export const HASTRA_IMAGE_URI = "https://patient.hastra.us/hastra-app//uploads/images/";

export const ORTHANC_URL = "https://doctor.hastra.us/orthanc/";
export const DIACOM_WEB_URI = "https://doctor.hastra.us/orthanc/dicom-web";

export const HUSTRA_CHAT_URI = "https://patient.hastra.us"; 
export const SOCKET_PATH = "/hastra-chat/socket.io"; 